import AuthTypes from '../types/AuthTypes';
import { isAuthenticated } from '../../utils/AuthConfig';

const initialState = isAuthenticated()
  ? { loggedIn: true, isLoading: true }
  : {
      loggedIn: false,
      verifyEmailStatus: false,
      verifyLinkStatus: false,
      isLoading: true
    };

// eslint-disable-next-line default-param-last
const authentication = (state = initialState, action) => {
  switch (action.type) {
    case AuthTypes.LOGIN_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case AuthTypes.LOGIN_SUCCESS:
      return {
        ...state,
        loggedIn: true,
        isLoading: false,
        data: action.data
      };
    case AuthTypes.LOGIN_ERROR:
      return {
        ...state,
        loggedIn: false,
        isLoading: false
        // error: action.error,
      };
    // case AuthTypes.LOGOUT:
    //   return {
    //     ...initialState, // Reset the session state
    //   };

    // case AuthTypes.FORGOT_PASSWORD_REQUEST:
    //   return { isLoading: true };
    // case AuthTypes.FORGOT_PASSWORD_SUCCESS:
    //   return {
    //     ...state,
    //     isLoading: false,
    //     forgortData: action.data,
    //   };
    // case AuthTypes.FORGOT_PASSWORD_ERROR:
    //   return { error: action.error };

    // case AuthTypes.RESET_PASSWORD_REQUEST:
    //   return {
    //     ...state,
    //     isLoading: true,
    //   };
    // case AuthTypes.RESET_PASSWORD_SUCCESS:
    //   return {
    //     ...state,
    //     isLoading: false,
    //     data: action.data,
    //   };
    // case AuthTypes.RESET_PASSWORD_ERROR:
    //   return {
    //     ...state,
    //     isLoading: false,
    //     error: action.error,
    //   };
    case AuthTypes.GET_RESET_PASSWORD_REQUEST:
      return {
        ...state,
        verifyLinkStatus: '',
        isLoading: true
      };
    case AuthTypes.GET_RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        verifyLinkStatus: true,
        data: action.data
      };
    case AuthTypes.GET_RESET_PASSWORD_ERROR:
      return {
        ...state,
        isLoading: false,
        verifyLinkStatus: false
        // error: action.data,
      };
    case AuthTypes.GET_SET_PASSWORD_REQUEST:
      return {
        ...state,
        verifyLinkStatus: '',
        isLoading: true
      };
    case AuthTypes.GET_SET_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        verifyLinkStatus: true,
        data: action.data
      };
    case AuthTypes.GET_SET_PASSWORD_ERROR:
      return {
        ...state,
        isLoading: false,
        verifyLinkStatus: false
        // error: action.data,
      };
    // case AuthTypes.GET_SET_PASSWORD_REQUEST:
    //   return {
    //     ...state,
    //     verifyLinkStatus: "",
    //     isLoading: true,
    //   };
    // case AuthTypes.GET_SET_PASSWORD_SUCCESS:
    //   return {
    //     ...state,
    //     isLoading: false,
    //     verifyLinkStatus: true,
    //     data: action.data,
    //   };
    // case AuthTypes.GET_SET_PASSWORD_ERROR:
    //   return {
    //     ...state,
    //     isLoading: false,
    //     verifyLinkStatus: false,
    //     error: action.error,
    //   };
    // case AuthTypes.VERIFY_EMAIL_REQUEST:
    //   return {
    //     ...state,
    //     verifyEmailStatus: "",
    //     isLoading: true,
    //   };
    // case AuthTypes.VERIFY_EMAIL_SUCCESS:
    //   return {
    //     ...state,
    //     isLoading: false,
    //     verifyEmailStatus: true,
    //     data: action.data,
    //   };
    // case AuthTypes.VERIFY_EMAIL_ERROR:
    //   return {
    //     ...state,
    //     isLoading: false,
    //     verifyEmailStatus: false,
    //     error: action.error,
    //   };
    case AuthTypes.LOGOUT_REQUEST:
      return {
        loggedIn: false,
        isLoading: false
      };
    case AuthTypes.LOGOUT_SUCCESS:
      return {
        loggedIn: false,
        isLoading: false
      };
    case AuthTypes.LOGOUT_ERROR:
      return {
        loggedIn: false,
        isLoading: false
      };

    default:
      return state;
  }
};

export default authentication;
